import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable'
import DashboardLayout from '../layout/Dashboard';
import { Navigate } from 'react-router';
import RequireVerified from '../auth/RequireVerified';

// main
const MainPage = Loadable(lazy(() => import('pages/main/MainPage')));

// make appointment 
const MakeAppointmentPage = Loadable(lazy(() => import('pages/makeAppointment/MakeAppointmentPage')));
const AppointmentByDirectionPage = Loadable(lazy(() => import('pages/makeAppointment/children/AppointmentByDirectionPage')));
const FreeAppointmentPage = Loadable(lazy(() => import('pages/makeAppointment/children/FreeAppointmentPage')));

// medcard 
const MedCardPage = Loadable(lazy(() => import('pages/medCard/MedCardPage')));
const AnalysisResultPage = Loadable(lazy(() => import('pages/medCard/children/AnalysisResultPage')));
const HospitalizationsPage = Loadable(lazy(() => import('pages/medCard/children/HospitalizationPage')));  
const ResearchPage = Loadable(lazy(() => import('pages/medCard/children/ResearchPage')))
const ExaminationPage = Loadable(lazy(() => import('pages/medCard/children/ExaminationPage')))
const DirectionPage = Loadable(lazy(() => import('pages/medCard/children/DirectionPage')))
const RecipePage = Loadable(lazy(() => import('pages/medCard/children/RecipePage')))
const RecommendationsPage = Loadable(lazy(() => import('pages/medCard/children/RecommendationsPage')))

// myAppointments
const MyAppointmentsPage = Loadable(lazy(() => import('pages/myAppointments/MyAppointmentsPage')));
const AppointmentDetailsPage = Loadable(lazy(() => import('pages/myAppointments/children/AppointmentDetailsPage')))

// promotions
const PromotionsPage = Loadable(lazy(() => import('pages/promotions/PromotionsPage')));
const DetailsPromotionsPage = Loadable(lazy(() => import('pages/promotions/children/DetailsPromotionsPage')));

// contacts 
const ContantPage = Loadable(lazy(() => import('pages/contacts/ContactsPage')));
const ClinicPage = Loadable(lazy(() => import('pages/contacts/children/ClinicPage')));

// cardDoctor
const CardDoctorPage = Loadable(lazy(() => import('pages/cardDoctor/СardDoctorPage')));

// profile
const ProfilePage = Loadable(lazy(() => import('pages/profile/ProfilePage')));

// DetailsAnalysisResPage
const DetailsAnalysisResPage = Loadable(lazy(() => import('pages/medCard/children/DetailsAnalysisResPage')));

// ChatFeedback
const ChatFeedbackPage = Loadable(lazy(() => import('pages/chatFeedback/ChatFeedbackPage')));

// Services
const ServicesPage = Loadable(lazy(() => import('pages/services/ServicesPage')));

// Payment
const PaymentPage = Loadable(lazy(() => import('pages/payment/PaymentPage')));

// Basket
const BasketPage = Loadable(lazy(() => import('pages/basket/BasketPage')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <RequireVerified>
      <DashboardLayout/>
    </RequireVerified>
  ),
  children: [
    {
      index: true,
      element: <Navigate to='/main' replace/>
    },
    {
      path: '/main',
      element: <MainPage />
    },
    {
      path: '/makeAppointment',
      element: <MakeAppointmentPage />,
      children: [
        {
          path: '/makeAppointment/direction',
          element: <AppointmentByDirectionPage/>
        },
        {
          path: '/makeAppointment/free',
          element: <FreeAppointmentPage/>
        }
      ]
    },
    {
      path: '/medCard',
      element: <MedCardPage />,
      children: [
        {
          path: '/medCard/analysisResults',
          element: <AnalysisResultPage />
        },
        {
          path: '/medCard/hospitalizations',
          element: <HospitalizationsPage />
        },
        {
          path: '/medCard/researches',
          element: <ResearchPage /> 
        },
        {
          path: '/medCard/examinations',
          element: <ExaminationPage/>
        },
        {
          path: '/medCard/directions',
          element: <DirectionPage />
        },
        {
          path: '/medCard/recipes',
          element: <RecipePage />
        },
        {
          path: '/medCard/analysisResults/DetailsAnalysisResPage/:id',
          element: <DetailsAnalysisResPage />
        },
        {
          path: '/medCard/recommendations',
          element: <RecommendationsPage />
        },
      ]
    },
    {
      path: '/myAppointments',
      element: <MyAppointmentsPage />,
      children: [
        {
          path: '/myAppointments/:id',
          element: <AppointmentDetailsPage />
        }
      ]
    },
    {
      path: '/promotions',
      element: <PromotionsPage />,
      children: [
        {
          path: '/promotions/:id',
          element: <DetailsPromotionsPage />
        }
      ]
    },
    {
      path: '/contacts',
      element: <ContantPage />,
      children: [
        {
          path: '/contacts/:id',
          element: <ClinicPage />
        }
      ]
    },
    {
      path: '/cardDoctor/:id',
      element: <CardDoctorPage />
    },
    {
      path: '/profile',
      element: <ProfilePage />
    },
    {
      path: '/chatFeedback',
      element: <ChatFeedbackPage />
    },
    {
      path: '/services',
      element: <ServicesPage />
    },
    {
      path: '/payment',
      element: <PaymentPage />
    },
    {
      path: '/basket',
      element: <BasketPage />
    }
  ]
};

export default MainRoutes;